export default {
  data() {
    return {
      effortRateHourly: {
        1: 0.0619,
        2: 0.0516,
        3: 0.0413,
        4: 0.031,
        5: 0.031,
        6: 0.031,
        7: 0.031,
        8: 0.0206,
        9: 0.0206,
      },
      hourlyWageReference: 4.85,
      isCustomMonthlySalary: false,
      // The rate limit to which the CMG applies
      maxNetHelp: 8,
      averageMonthlySalaryRange: [1426, 2000, 4000, 6000],
    };
  },
  computed: {
    averageMonthlySalaries() {
      return this.isCustomMonthlySalary ? [this.averageMonthlySalaryParsed] : this.averageMonthlySalaryRange;
    },
    /***
     *
     *  New CMG calculations
     *
     ***/

    /*****
     * This is the real total amount (net) paid to the assmat
     * including allowances (meal + transport + maintenance)
     ****/
    realMonthlyRateNet() {
      return this.maintenanceAllowanceMonthly +
          // this.transportAllowanceMonthly +
          this.mealAllowanceMonthly +
          this.net_mensualization_classic +
          this.net_monthy_overtime_increase;
    },
    realHourlyRateNet() {
      return this.realMonthlyRateNet / this.monthly_hours_f;
    },
    /*****
     * As we have a maximum of 8€ / hour (net) as rate paid for the cmg
     * we need to take the 8 euro if the amount paid to the assmat goes beyond
     ****/
    maxRealHourlyRate() {
      return Math.min(this.realHourlyRateNet, this.maxNetHelp);
    },
    youngestChildAgeTooOld() {
      return this.youngestChildAge === 'greater-than-twelve' ||
          (this.youngestChildAge === 'six-or-more' && this.situation !== 'single');
    },
    cmgNotAvailable() {
      return this.youngestChildAgeTooOld || this.cmgAidToggle === 'no';
    },
  },
  methods: {
    cmgEligibleAmount(parentMonthlySalaryNet) {
      if (this.cmgNotAvailable || parentMonthlySalaryNet < 0) {
        return 0;
      }

      return this.cmgPayable(parentMonthlySalaryNet) *
          (this.handicap_toggle ? 1.3 : 1) *
          (this.cmgAidToggle === 'partial' ? 0.5 : 1);
    },

    /*****
     * Formula to calculate the new CMG 2025
     * ```
     * real hourly rate * monthly worked hours * ( 1 - ( net parent salary * hourly effort rate / gross hourly rate reference) )
     * ```
     * `real hourly rate` should have all the allowances, i.e. meal and maintenance, plus
     * the hourly rate the employee perceives
     *****/
    cmgPayable(parentMonthlySalaryNet) {
      const cmgAmount = this.maxRealHourlyRate * this.monthly_hours_f *
          (1 - (parentMonthlySalaryNet * this.effortRateHourly[this.children_i] / 100 / this.hourlyWageReference));
      return Math.max(0, cmgAmount);
    },

    taxesCredit(parentMonthlySalaryNet) {
      const taxMax = Math.max(
        (
          this.grossTotal +
              this.social_contributions_employer +
              Math.min(this.maintenanceAllowanceMonthlyDetaxLimit, this.maintenanceAllowanceMonthly) -
              this.socialContributionsCredit -
              this.cmgEligibleAmount(parentMonthlySalaryNet) -
              this.other_aid_f
        ) * 12 / 2,
        0
      );

      return this.child_age_option.toString() === '6' ? 0 : Math.min(taxMax, this.taxLimit);
    },
    amountLeftPayable(parentMonthlySalaryNet) {
      return Math.max(this.total_amount -
          this.socialContributionsCredit -
          this.cmgEligibleAmount(parentMonthlySalaryNet) -
          this.other_aid_f -
          (this.taxesCredit(parentMonthlySalaryNet) / 12), 0);
    },
    amountLeftPayableBeforeTaxes(parentMonthlySalaryNet) {
      return Math.max(this.total_amount -
          this.socialContributionsCredit -
          this.cmgEligibleAmount(parentMonthlySalaryNet) -
          this.other_aid_f, 0);
    },
    dailyCost(parentMonthlySalaryNet) {
      return this.amountLeftPayable(parentMonthlySalaryNet) / this.monthly_worked_days_f;
    },
    hourlyCost(parentMonthlySalaryNet) {
      return this.amountLeftPayable(parentMonthlySalaryNet) / this.monthly_hours_f;
    },

  },
};
